export const countrySpecificAnalysisData = {
  Austria: [
    {
      countryRegion: 'Austria',
      localTitle: 'Kreislaufwirtschaftsprofil 2024 – Österreich',
      englishTitle: 'Circular economy country profile 2024 - Austria',
      link:
        'https://www.eea.europa.eu/en/topics/in-depth/circular-economy/country-profiles-on-circular-economy/circular-economy-country-profiles-2024/austria_2024-ce-country-profile_final.pdf/@@download/file'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Kreislaufwirtschaft - Materialflüsse in Österreich im Jahr 2023',
      englishTitle: 'Circular economy – material flows in Austria in 2023',
      link: 'https://kreislaufwirtschaft.statistik.at/kreislaufwirtschaft/'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Erster Fortchrittsbericht 2024 - österreichische Kreislaufwirtschaftsstrategie',
      englishTitle: 'First progress report 2024 – Austrian circular economy strategy',
      link:
        'https://www.bmluk.gv.at/dam/jcr:784648a7-41f6-4740-8123-ce96415313df/Fortschrittsbericht_1_zur_oesterreichischen_Kreislaufwirtschaftsstrategie%20(1).pdf%E2%80%9D'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'Länderbericht Österreich 2025 zur digitalen Dekade',
      englishTitle: 'Austria 2025 Digital Decade Country Report',
      link: 'https://digital-strategy.ec.europa.eu/en/factpages/austria-2025-digital-decade-country-report'
    },
    {
      countryRegion: 'Austria',
      localTitle: 'OECD Country Note: Umsetzung des EU‑KI‑Koordinationsplans (Austria)',
      englishTitle: 'OECD Country Note: Implementation of the EU-KI Coordination Plan (Austria)',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2025/10/progress-in-implementing-the-european-union-coordinated-plan-on-artificial-intelligence-volume-1-country-notes_b0385317/austria_c06ec63f/ccf9b51e-en.pdf'
    }
  ],
  Romania: [
    {
      countryRegion: 'Romania',
      localTitle: 'Profil de țară privind economia circulară 2024 – România',
      englishTitle: 'Circular economy country profile 2024 – Romania',
      link:
        'https://www.eea.europa.eu/en/topics/in-depth/circular-economy/country-profiles-on-circular-economy/circular-economy-country-profiles-2024/romania_2024-ce-country-profile_final.pdf/%40%40download/file'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Raport de țară 2024 – România (Semestrul European)',
      englishTitle: '2024 European Semester Country Report – Romania',
      link:
        'https://economy-finance.ec.europa.eu/document/download/dcac26a0-120e-4233-88b6-8c7b0d919257_en?filename=SWD_2024_623_1_EN_Romania.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Raport de țară 2025 privind Deceniul Digital – România',
      englishTitle: 'Romania 2025 Digital Decade Country Report',
      link: 'https://digital-strategy.ec.europa.eu/en/factpages/romania-2025-digital-decade-country-report'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Plan național de acțiune privind Deceniul Digital pentru România (Roadmap)',
      englishTitle: 'National Action Plan on the Digital Decade for Romania (Roadmap)',
      link: 'https://www.mcid.gov.ro/wp-content/uploads/2024/04/Plan-national-de-actiune-roadmap-pentru-publicare.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Planul de acțiune privind economia circulară pentru România',
      englishTitle: 'Circular Economy Action Plan for Romania (PAEC 2024–2032)',
      link: 'https://www.mmediu.ro/app/webroot/uploads/files/Planul%20de%20Actiune%20pentru%20SNEC.pdf'
    },
    {
      countryRegion: 'Romania',
      localTitle: 'Strategia Națională de Cercetare, Inovare și Specializare Inteligentă 2022–2027',
      englishTitle: 'National Strategy for Research, Innovation and Smart Specialisation 2022–2027',
      link: 'https://uefiscdi.gov.ro/resource-867892-SNCISIenglish-version.pdf'
    }
  ],
  Germany: [
    {
      countryRegion: 'Germany',
      localTitle: 'Die Nutzung natürlicher Ressourcen. Bericht für Deutschland 2022',
      englishTitle: 'The Use of Natural Resources – Resources Report for Germany 2022',
      link: 'https://www.umweltbundesamt.de/ressourcenbericht2022'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'Circular Economy Roadmap für Deutschland (2021)',
      englishTitle: 'Circular Economy Roadmap for Germany',
      link: 'https://www.circular-economy-initiative.de/circular-economy-roadmap-for-germany'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'GreenTech made in Germany 2021 – Umwelttechnik-Atlas',
      englishTitle: 'GreenTech Atlas 2025 (Environmental Technology Atlas)',
      link: 'https://www.umweltbundesamt.de/en/topics/economics-consumption/greentech-atlas-2025'
    },
    {
      countryRegion: 'Germany',
      localTitle: 'Umweltzustandsbericht 2021 (Umweltdaten Baden-Württemberg)',
      englishTitle: 'Environment State Report 2021 Baden-Württemberg',
      link: 'https://pd.lubw.de/10246'
    }
  ],
  Croatia: [
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o elektroničkim komunikacijama',
      englishTitle: 'Electronic Communications Act (ECA)',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2022_07_76_1116.html?utm_source'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o provedbi Opće uredbe o zaštiti podataka',
      englishTitle: 'Act on the Implementation of the General Data Protection Regulation',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2018_05_42_805.html'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o informacijskoj sigurnosti',
      englishTitle: 'Information Security Act',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2007_07_79_2484.html'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o ravnopravnosti spolova',
      englishTitle: 'Act on Gender Equality',
      link:
        'https://ravnopravnost.gov.hr/UserDocsImages/dokumenti/Zakoni/2018/Act%20on%20Gender%20Equality%20ENG.pdf?utm_source'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o suzbijanju diskriminacije',
      englishTitle: 'Anti-Discrimination Act',
      link:
        'https://www.migpolgroup.com/wp-content/uploads/2025/08/2025-HR-Country-report-ND-final-for-web.pdf?utm_source'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o gospodarenju otpadom',
      englishTitle: 'Waste Management Act',
      link:
        'https://mzozt.gov.hr/o-ministarstvu-1065/djelokrug/uprava-za-procjenu-utjecaja-na-okolis-i-odrzivo-gospodarenje-otpadom-1271/gospodarenje-otpadom/sustainable-waste-management-7591/7591'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o zaštiti okoliša',
      englishTitle: 'Environmental Protection Act',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2013_06_80_1654.html'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o klimatskim promjenama i zaštiti ozonskog sloja',
      englishTitle: 'Climate Change and Ozone Layer Protection Act',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2019_12_127_2531.html'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o poticanju razvoja malog gospodarstva',
      englishTitle: 'Small Business Development Promotion Act',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2002_03_29_713.html'
    },
    {
      countryRegion: 'Croatia',
      localTitle: 'Zakon o energetskoj učinkovitosti',
      englishTitle: 'Energy Efficiency Act',
      link: 'https://narodne-novine.nn.hr/clanci/sluzbeni/2014_10_127_2457.html'
    }
  ],
  Bulgaria: [
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Икономически прегледи на ОИСР',
      englishTitle: 'OECD Economic Surveys',
      link: 'https://www.oecd.org/en/countries/bulgaria.html'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Европейска икономическа прогноза',
      englishTitle: 'European Economic Forecast',
      link: 'https://economy-finance.ec.europa.eu/economic-forecast-and-surveys/economic-forecasts_en'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Регионален преглед на ОИСР 2023',
      englishTitle: 'OECD Regional Outlook 2023',
      link: 'https://www.oecd.org/regional/oecd-regional-outlook-2023.htm'
    },
    {
      countryRegion: 'Bulgaria',
      localTitle: 'Консултации по член IV за 2025г',
      englishTitle: 'Bulgaria 2025 Article IV Consultation',
      link: 'https://www.imf.org/en/Countries/BGR'
    }
  ],
  Slovenia: [
    {
      countryRegion: 'Slovenia',
      localTitle: 'Načrt za krožno gospodarstvo v Sloveniji',
      englishTitle: 'Roadmap towards the circular economy in Slovenia',
      link:
        'https://circulareconomy.europa.eu/platform/sites/default/files/roadmap_towards_the_circular_economy_in_slovenia.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Strategija pametne specializacije Slovenije',
      englishTitle: 'Slovenia’s Smart Specialisation Strategy',
      link:
        'https://evropskasredstva.si/en/slovenias-cohesion-policy-programme-2021-2027/slovenias-smart-specialisation-strategy/'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Slovenija: Integracija enakosti spolov',
      englishTitle: 'Slovenia: Gender mainstreaming',
      link: 'https://eige.europa.eu/gender-mainstreaming/countries/slovenia'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Krožna Slovenija: nacionalni, strateški pristop',
      englishTitle: 'Circular Slovenia: a national, strategic approach',
      link: 'https://circulareconomy.leeds.ac.uk/wp-content/uploads/sites/35/2021/04/Circular-Slovenia_final.pdf'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Slovenija - Digitalna Slovenija 2030',
      englishTitle: 'Slovenia - Digital Slovenia 2030',
      link:
        'https://digital-skills-jobs.europa.eu/en/actions/national-initiatives/national-strategies/slovenia-digital-slovenia-2030'
    },
    {
      countryRegion: 'Slovenia',
      localTitle: 'Načrt za izvajanje nabora orodij za povezljivost v republici sloveniji',
      englishTitle: 'Roadmap for the implementation of the toolbox for connectivity in the republic of slovenia',
      link:
        'https://www.gov.si/assets/ministrstva/MGTS/Dokumenti/DIPT/Digitalizacija/Roadmap-for-the-implementation-of-the-toolbox-for-connectivity-in-the-Republic-of-Slovenia.pdf'
    }
  ],
  Czechia: [
    {
      countryRegion: 'Czechia',
      localTitle: 'Národní profil oběhového hospodářství 2024 – Česko',
      englishTitle: 'Circular economy country profile\n2024 – Czechia',
      link:
        'https://www.eea.europa.eu/en/topics/in-depth/circular-economy/country-profiles-on-circular-economy/circular-economy-country-profiles-2024/czechia_2024-ce-country-profile_final.pdf/@@download/file'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Směrem k národnímu strategickému rámci pro oběhové hospodářství v České republice',
      englishTitle: 'Towards a National Strategic Framework for the Circular Economy in the Czech Republic',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2021/06/towards-a-national-strategic-framework-for-the-circular-economy-in-the-czech-republic_5192eef5/5d33734d-en.pdf'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Zpráva o stavu digitální dekády 2025',
      englishTitle: 'Czech Republic 2025 Digital Decade\nCountry Report',
      link: 'https://digital-strategy.ec.europa.eu/en/node/13714/printable/pdf'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Zpráva o životním prostředí v Evropě 2025- Česko',
      englishTitle: 'Europe’s Environment 2025- Czechia country profile',
      link:
        'https://www.eea.europa.eu/en/europe-environment-2025/countries/czechia?activeAccordion=61200386-1268-4979-a58a-4f7b22159d63'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Odpadové hospodářství- Česko',
      englishTitle: 'Waste management country profile',
      link:
        'https://www.eea.europa.eu/en/topics/in-depth/waste-and-recycling/municipal-and-packaging-waste-management-country-profiles-2025/cz-municipal-waste-factsheet.pdf/@@download/file'
    },
    {
      countryRegion: 'Czechia',
      localTitle:
        'Srovnávací analýza shrnutí strategií inteligentní specializace (S3) Horního Rakouska a Jihočeského kraje',
      englishTitle:
        'Comparative analysis of S3 abstracts\nof the strategies of Upper Austria and\nthe South Bohemian Region',
      link:
        'https://www.s3cn.eu/files/s3cn/uploads/files/16618569845947-269-s3cn-at121-comparative-analysis-ver-final-en-rev2.pdf'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Rovnost mužů a žen v České republice',
      englishTitle: 'Gender Equality in the Czech Republic',
      link: 'https://www.oecd.org/en/publications/gender-equality-in-the-czech-republic_c5a3086f-en.html'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Česká republika v Indexu digitální ekonomiky a společnosti (DESI)',
      englishTitle: 'Czech Republic in the Digital Economy and Society Index',
      link: 'https://digital-strategy.ec.europa.eu/en/policies/desi-czech-republic'
    },
    {
      countryRegion: 'Czechia',
      localTitle: 'Výhled digitální ekonomiky OECD 2024 (volume 2)',
      englishTitle: 'OECD Digital Economy\nOutlook 2024 (Volume 2)- notes to Czechia',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2024/11/oecd-digital-economy-outlook-2024-volume-2_9b2801fc/3adf705b-en.pdf'
    }
  ],
  'Slovak republic': [
    {
      countryRegion: 'Slovakia',
      localTitle:
        'Slovensko uzatvára kruh:\nCestovná mapa pre obehové\nhospodárstvo - Smerom ku\nkonkurencieschopnosti,\nekoinováciám a udržateľnosti',
      englishTitle:
        'Closing the Loop in the Slovak Republic: A Roadmap Towards Circularity for Competitiveness, Ecoinnovation and Sustainability',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2022/07/closing-the-loop-in-the-slovak-republic_4bb9131f/acadd43a-en.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'PLÁN OBNOVY: Cestovná mapa k lepšiemu Slovensku',
      englishTitle: 'RECOVERY AND RESILIENCE PLAN: The Path to a Better Slovakia',
      link: 'https://www.planobnovy.sk/site/assets/files/1019/kompletny-plan-obnovy.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Národný plán obnovy a odolnosti Slovenska – najnovší stav',
      englishTitle: 'Slovakia’s National Recovery and Resilience Plan Latest state of play',
      link: 'https://www.europarl.europa.eu/RegData/etudes/BRIE/2022/733642/EPRS_BRI(2022)733642_EN.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Klimatické iniciatívy z pohľadu MSP',
      englishTitle: 'Climate initiatives from an SME perspective',
      link: 'https://www.sbagency.sk/sites/default/files/klimaticke_iniciativy_z_pohladu_msp.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle:
        'Analýza potrieb MSP v kontexte agendy inteligentného priemyslu a špecificky vo vzťahu k potrebe ľudských zdrojov do roku 2020/2030',
      englishTitle:
        'Analysis of SME needs in the context of the smart industry agenda and specifically in relation to human resource needs by 2020/2030',
      link:
        'https://www.sbagency.sk/sites/default/files/analyza_potrieb_msp_v_kontexte_agendy_inteligentneho_priemyslu.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Analýza bariér malých a stredných podnikov v oblasti digitalizácie',
      englishTitle: 'Analysis of barriers to digitalization for small and medium-sized enterprises',
      link:
        'https://www.sbagency.sk/sites/default/files/analyza_barier_malych_a_strednych_podnikov_v_oblasti_digitalizacie.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Vedecko - výskumné a expertné kapacity v obehovom hospodárstve',
      englishTitle: 'Research and expert capacities in circular economy',
      link: 'https://drive.google.com/file/d/13o1pi-un_ze4_ihyxCQLExJYC_IxDrW4/view?usp=sharing'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Greenwashing',
      englishTitle: 'Greenwashing',
      link: 'https://www.incien.sk/wp-content/uploads/2024/11/Greenwashing-publikacia.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Udržateľnosť potravinového systému na Slovensku',
      englishTitle: 'Sustainability of Slovakia’s Food System',
      link: 'https://www.incien.sk/wp-content/uploads/2024/05/incien_udrzatelny_potravin_system_final.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Manuál zelenej kultúrnej produkcie',
      englishTitle: 'Green cultural production manual',
      link: 'https://www.trencin2026.eu/wp-content/uploads/2024/10/Manual-zelenej-kulturnej-produkcie.pdf'
    },
    {
      countryRegion: 'Slovakia',
      localTitle: 'Kolobeh uhlíka a uhlíkové kompenzácie',
      englishTitle: 'Carbon cycle and carbon offsets',
      link: 'https://www.incien.sk/wp-content/uploads/2023/03/incien_karbon_final_2.pdf'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o ravnopravnosti spolova u Bosni i Hercegovini',
      englishTitle: 'Law on Gender Equality in Bosnia and Herzegovina',
      link:
        'https://www.ohr.int/ohr-dept/legal/laws-of-bih/pdf/008%20-%20HUMAN%20RIGHTS%20OMBUDSMAN%20OF%20BOSNIA%20AND%20HERZEGOVINA/BH%20LAW%20ON%20GENDER%20EQUALITY%20IN%20BOSNIA%20AND%20HERZEGOVINA%2016-03.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o zabrani diskriminacije Bosne i Hercegovine',
      englishTitle: 'Law on Prohibition of Discrimination (BiH)',
      link: 'https://arsbih.gov.ba/wp-content/uploads/2014/02/002-Anti-Discrimination-Law-.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o elektronskom potpisu Bosne i Hercegovine (Službeni glasnik BiH 91/06)',
      englishTitle: 'Law on Electronic Signatures (BiH)',
      link:
        'https://dig.watch/resource/the-law-on-electronic-signatures-in-bosnia-and-herzegovina?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o komunikacijama Bosne i Hercegovine',
      englishTitle: 'Law on Communications of Bosnia and Herzegovina',
      link:
        'https://advokat-prnjavorac.com/legislation/Law-on-communications-of-Bosnia-and-Herzegovina.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o upravljanju otpadom (Federacija BiH)',
      englishTitle: 'Law on Waste Management (Federation of BiH)',
      link: 'https://oilgas.fmeri.gov.ba/media/1123/fbih-the-law-on-waste-management.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o izmjenama i dopunama Zakona o upravljanju otpadom (FBiH)',
      englishTitle: 'Law on Amendments to the Law on Waste Management (FBiH)',
      link: 'https://www.ekopak.ba/files/admin/docs/c26f4e3284505aab615f88c547c053b2.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Pravilnik o upravljanju otpadnom električnom i elektronskom opremom (WEEE) (FBiH)',
      englishTitle: 'Rulebook on Management of Waste Electrical and Electronic Products (FBiH)',
      link: 'https://www.zeos.ba/en/11/pages/5/law-and-rulebook?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Uredba o ambalaži i upravljanju ambalažnim otpadom (FBiH)',
      englishTitle: 'Regulation on Packaging and Packaging Waste Management (FBiH)',
      link: 'https://respect.ba/en/regulation-on-packaging-and-packaging-waste-management/?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o upravljanju otpadom (Republika Srpska)',
      englishTitle: 'The Law on Waste Management (Republika Srpska)',
      link:
        'https://vladars.rs/sr-SP-Cyrl/Vlada/Ministarstva/mgr/Documents/The%20Law%20on%20Waste%20Management_299417824.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Zakon o izmjenama Zakona o upravljanju otpadom (RS)',
      englishTitle: 'Law on Amendments to the Law on Waste Management (RS)',
      link:
        'https://www.vladars.net/sr-SP-Cyrl/Vlada/Ministarstva/mgr/Documents/The%20Law%20on%20Amendments%20to%20the%20Law%20on%20Waste%20Management_295505322.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'RBosnia and Herzegovina',
      localTitle: 'Zakon o elektronskom novcu (RS)',
      englishTitle: 'Law on Electronic Money (RS)',
      link: 'https://abrs.ba/wp-content/uploads/2025/06/LawOnElectronicMoney22122023.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Okvir za realizaciju Ciljeva održivog razvoja u Bosni i Hercegovini',
      englishTitle: 'Framework for the Implementation of Sustainable Development Goals in Bosnia and Herzegovina',
      link: 'https://zamisli2030.ba/wp-content/uploads/2024/03/VNR2023_ENG_web.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Okvir saradnje UN-a za održivi razvoj BiH 2021–2025',
      englishTitle: 'United Nations Sustainable Development Cooperation Framework (2021–2025)',
      link: 'https://bosniaherzegovina.un.org/sites/default/files/2022-08/2022%20UNSDCF_BiH_JWP%20final%20ENG.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Bosnia and Herzegovina Digital Development Country Profile',
      englishTitle: 'Digital Development Country Profile (ITU)',
      link:
        'https://www.itu.int/en/ITU-D/Regional-Presence/Europe/Documents/Publications/2023/Digital%20Development%20Country%20Profile%20Bosnia%20and%20Herzegovina%20%5Bfinal-%20March%202023%5D.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Bosnia and Herzegovina – Circular Economy White Paper',
      englishTitle: 'Circular Economy White Paper for Bosnia and Herzegovina',
      link: 'https://zelenaekonomija.komorabih.ba/wp-content/uploads/2023/10/White_Paper_Publication_28042022.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Dobrovoljni izvještaj BiH o provođenju Agende 2030 i Ciljeva održivog razvoja',
      englishTitle: 'Voluntary National Review of Agenda 2030 & SDGs (2019 / 2023)',
      link: 'https://zamisli2030.ba/wp-content/uploads/2024/03/VNR2023_ENG_web.pdf'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'Agencija za statistiku BiH – Ciljevi održivog razvoja: Indikatori i Mapa puta',
      englishTitle: 'SDG progress and indicators reports (periodic)',
      link: 'https://bhas.gov.ba/Calendar/Category/33'
    },
    {
      countryRegion: 'Bosnia and Herzegovina',
      localTitle: 'UNDP Country Programme Document BiH 2026–2030',
      englishTitle: 'UNDP Programme Document supporting circular economy & digital transformation',
      link: 'https://www.undp.org/sites/g/files/zskgke326/files/2025-09/cpd_bih_eng_20262030_0.pdf'
    }
  ],
  Moldova: [
    {
      countryRegion: 'Moldova',
      localTitle: 'Strategia Națională de Dezvoltare ’Moldova Europeană 2030’',
      englishTitle: 'National Development Strategy ’European Moldova 2030’',
      link:
        'https://mded.gov.md/?s=Strategia+Na%C8%9Bional%C4%83+de+Dezvoltare+%E2%80%9EMoldova+European%C4%83+2030%E2%80%9D'
    },
    {
      countryRegion: 'Moldova',
      localTitle: 'Strategia Națională de Dezvoltare Economică 2030',
      englishTitle: 'National Economic Development Strategy 2030',
      link: 'https://mded.gov.md'
    },
    {
      countryRegion: 'Moldova',
      localTitle: 'Programul pentru promovarea economiei verzi și circulare 2024–2028',
      englishTitle: 'Programme for Promoting Green and Circular Economy 2024–2028',
      link: 'https://climate-laws.org/'
    },
    {
      countryRegion: 'Moldova',
      localTitle: 'Strategia de Mediu 2014–2023',
      englishTitle: 'Environmental Strategy 2014–2023',
      link: 'https://www.unep.org/resources/report/environmental-strategy-years-2014-2023'
    }
  ],
  Hungary: [
    {
      countryRegion: 'Hungary',
      localTitle: 'KKV-k a közbeszerzésben',
      englishTitle: 'SMEs in Public Procurement',
      link:
        'https://www.oecd.org/en/publications/smes-in-public-procurement_9789264307476-en/full-report/component-24.html'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Szociális gazdaság Európában: Magyarország',
      englishTitle: 'Social Economy in Europe: Hungary',
      link:
        'https://www.oecd.org/en/publications/social-economy-in-europe_12970cca-en/hungary_dbacd7eb-en.html#section-d1e967'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'KKV Fact sheet – Magyarország',
      englishTitle: 'SME Performance Review – Hungary (SBA Fact Sheet)',
      link:
        'https://single-market-economy.ec.europa.eu/document/download/b29122ae-a059-4a96-9282-fb27add04021_en?filename=Hungary%20-%20SME%20Fact%20Sheet%202025.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Európai Szemeszter Országjelentés – Magyarország',
      englishTitle: 'European Semester Country Report – Hungary',
      link: 'https://economy-finance.ec.europa.eu/economic-surveillance-eu-economies/hungary_en'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nemi Egyenlőségi Országprofil – Magyarország',
      englishTitle: 'Gender Equality Country Profile – Hungary (EIGE)',
      link: 'https://eige.europa.eu/gender-equality-index'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Magyarország Digitális Gazdaság és Társadalom Jelentés',
      englishTitle: 'Digital Economy and Society Index (DESI) – Hungary',
      link: 'https://digital-strategy.ec.europa.eu/en/policies/desi-hungary'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Úton Magyarország\nkörforgásos gazdaságot\ncélzó nemzeti\nstratégiája felé',
      englishTitle: 'Highlights toward a National Circular Economy Strategy for Hungary',
      link:
        'https://www.oecd.org/content/dam/oecd/en/publications/reports/2023/04/towards-a-national-circular-economy-strategy-for-hungary_b9db4b7f/1178c379-en.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nők a vállalkozás frontvonalában (Kozma Tímea – Györpál Tünde)',
      englishTitle: 'Women on the front lines of business',
      link:
        'https://epa.oszk.hu/03400/03448/00005/pdf/EPA03448_multidiszciplinaris_2015_1_060-071.pdf?utm_source=chatgpt.com'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Female entrepreneurs – women in enterprises: (Hungary-focused working paper)',
      englishTitle: 'Female entrepreneurs – women in enterprises: (Hungary-focused working paper)',
      link: 'https://hetfa.hu/wp-content/uploads/2018/02/hetfa_wp_27_bobak_geambasu_radnai_zsar.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Női vállalkozók - Kutatási területek (Gódány Zsuzsanna)',
      englishTitle: 'Women entrepreneurs - Research areas',
      link: 'https://unipub.lib.uni-corvinus.hu/3387/1/VT_2018n4p58.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'A női vállalkozók hatása a gazdaságra, motivációik és nehézségeinek vizsgálata',
      englishTitle: 'The impact of female entrepreneurs on the economy, examining their motivations and difficulties',
      link: 'https://dea.lib.unideb.hu/items/f4e8dce3-e9eb-4b1f-99cf-4f97e3555859/full'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nők és férfiak vállalkozási hajlandósága, attitűdjei, vállalkozási aktivitása Magyarországon',
      englishTitle: 'Entrepreneurial propensity, attitudes, and activity among women and men in Hungary',
      link: 'https://topap.hu/cms/uploads/337_354_TRIP_2024_Csakne_Szennay_bcb524b1ae.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Női Vállalkozók Magyarországon',
      englishTitle: 'Women Entrepreneurs in Hungary',
      link: 'https://publikaciotar.uni-bge.hu/id/eprint/2278/1/GEM_women_report.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Női vállalkozók Európában',
      englishTitle: 'Women entrepreneurs in Europe',
      link: 'https://ifempower.eu/wp-content/uploads/2019/12/ifempower_intellectual-output_1_final_HU.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Vállalkozás női módra\nSzempontok és ajánlások vállalkozásfejlesztőknek',
      englishTitle: 'Entrepreneurship for women\nConsiderations and recommendations for business developers',
      link: 'https://jol-let.com/magyar/wp-content/uploads/V%C3%A1llalkoz%C3%A1s-n%C5%91i-m%C3%B3dra.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Beszámoló a nők helyzetéről a perifériás ipari régiók munkaerőpiacain',
      englishTitle: 'Input paper on the position of women in the labour markets of peripheral industrial regions',
      link: 'https://interreg-danube.eu/projects/win/library?page=1'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Vállalkozónők a koronavírus idején néhány európai országban',
      englishTitle: 'Women entrepreneurs during the coronavirus pandemic in some European countries',
      link: 'https://hetfa.hu/wp-content/uploads/2020/10/noi-vallalkozok_nemzetkozi_FINAL.pdf'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'A nők vállalkozási hajlandóságának vizsgálata Magyarországon',
      englishTitle: 'Examining women’s entrepreneurial propensity in Hungary',
      link:
        'https://www.researchgate.net/publication/343628563_A_nok_vallalkozasi_hajlandosaganak_vizsgalata_Magyarorszagon'
    },
    {
      countryRegion: 'Hungary',
      localTitle: 'Nők a startup-vállalkozások világában Magyarországon',
      englishTitle: 'Women in the world of start-ups in Hungary',
      link: 'https://www.researchgate.net/publication/344580963_Nok_a_startup-vallalkozasok_vilagaban_Magyarorszagon'
    },
    {
      countryRegion: 'Hungary',
      localTitle:
        'Nők szerepe a vidékfejlesztésben és a gazdaságfejlesztésben a Bács-Kiskun Megyei női vállalkozók körében végzett felmérés alapján',
      englishTitle:
        'The role of women in rural development and economic development based on a survey conducted among female entrepreneurs in Bács-Kiskun County',
      link: 'https://www.bkmkik.hu/attachments/article/4859/N%C5%91k%20a%20vid%C3%A9kfejleszt%C3%A9sben%202021.pdf'
    }
  ],
  Serbia: [
    {
      countryRegion: 'Serbia',
      localTitle: 'Nacionalna strategija za rodnu ravnopravnost za period od 2021-2030',
      englishTitle: 'The Gender Equality Strategy for the Period 2021-2030',
      link: 'https://www.rodnaravnopravnost.gov.rs/sites/default/files/2022-03/National Strategy for GE 2021-2030.pdf'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Strategija niskougljeničnog razvoja Republike Srbije za period od 2023. do 2030.',
      englishTitle: 'Low-Carbon Development Strategy for 2023–2031',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2023-11/low_carbon_development_strategy_of_the_republic_of_serbia_for_the_period_2023-_2030_with_projections_until_2050.pdf'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Program upravljanja otpadom u Republici Srbiji za period 2022-2031. godine',
      englishTitle: 'Waste Management Programme for 2022–2031',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2022-03/program_upravljanja_otpadom_eng_-_adopted_version.pdf'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Program razvoja cirkularne ekonomije u Republici Srbiji za period 2022–2024. godine',
      englishTitle:
        'Program for Development of Circular Economy in the Republic of Serbia for the period 2022-2024 year',
      link:
        'https://www.ekologija.gov.rs/sites/default/files/2022-12/program_razvoja_cirkularne_ekonomije_u_republici_srbiji_za_period_2022-2024._godine__0.pdf'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Mapa puta za cirkularnu ekonomiju u Srbiji',
      englishTitle: 'ROADMAP for circular economy in Serbia',
      link: 'https://circulareconomy.europa.eu/platform/sites/default/files/roadmap-for-circular-economy-in-serbia.pdf'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Nacionalna strategija održivog razvoja',
      englishTitle: 'The National Strategy for Sustainable Development',
      link: 'https://pravno-informacioni-sistem.rs/eli/rep/sgrs/vlada/strategija/2008/57/1/reg'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Strategija za razvoj malih i srednjih preduzeća za period od 2023. do 2027.',
      englishTitle: 'Strategy for the Development of Small and Medium Enterprises 2023-2027',
      link:
        'https://privreda.gov.rs/lat/dokumenta/propisi/strategije/strategija-za-razvoj-malih-i-srednjih-preduzeca-za-period-od-2023-do-2027-godine'
    },
    {
      countryRegion: 'Serbia',
      localTitle: 'Strategija pametne specijalizacije u Republici Srbiji 2020-2027',
      englishTitle: 'Smart Specialisation Strategy of the Republic of Serbia 2020-2027',
      link:
        'https://pametnaspecijalizacija.mpn.gov.rs/wp-content/uploads/2021/06/Strategija-pametne-specijalizacije_EN_WEB.pdf'
    }
  ]
}
